import { render, staticRenderFns } from "./StaticTableView.vue?vue&type=template&id=60214e80&"
import script from "./StaticTableView.vue?vue&type=script&lang=js&"
export * from "./StaticTableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports